import React, { useEffect, useState } from "react";
import { classNames } from "../../helpers/classNames";

const SubItem = ({ data }) => {
  return (
    <>
      <div className="relative py-2 space-y-0.5">
        {data?.name && (
          <div className="text-xs 2xl:text-sm text-md-dark font-medium !leading-none">
            {data?.name}
          </div>
        )}
        {data?.description && (
          <div className="text-xs 2xl:text-sm text-slate-700 !leading-none">
            {data?.description}
          </div>
        )}
        {data?.date && (
          <div className="text-[10px] 2xl:text-xs text-slate-400 !leading-none">
            {data?.date?.dayname +
              ", " +
              data?.date?.day +
              " " +
              data?.date?.month +
              ", " +
              data?.date?.year +
              " - " +
              data?.date?.time +
              "hrs"}
          </div>
        )}
      </div>
    </>
  );
};

const TrackingItem = ({ data, index, length }) => {
  const [calculatedHeight, setCalculatedHeight] = useState(0);

  useEffect(() => {
    if (length !== index) {
      setCalculatedHeight(
        data?.statuspercentage > 7 ? data?.statuspercentage + "%" : "7%"
      );
    }
  }, [data?.statuspercentage, index, length]);

  return (
    <>
      <div
        className={classNames(
          "relative pl-10 pt-1.5 2xl:pl-12",
          length !== index + 1 ? "pb-4" : ""
        )}
      >
        <div className="absolute top-0 left-0 h-full">
          <div
            className={classNames(
              "absolute top-4 left-3.5 w-1 h-full bg-slate-200 overflow-hidden",
              length !== index + 1 ? "h-full" : "h-[calc(100%-(1.5rem))]"
            )}
          >
            <div
              className="absolute top-0 left-0 w-full bg-green-500 rounded-full transition-all duration-300"
              style={{ height: calculatedHeight }}
            />
          </div>
          <div
            className={classNames(
              "absolute top-0 left-0 w-8 aspect-square flex items-center justify-center rounded-full text-sm  border-[3px] border-white shadow-md",
              data?.statuspercentage > 7
                ? "bg-green-500 text-white"
                : "bg-yellow-400  text-white"
            )}
          >
            <i className={classNames("fa-fw", data?.icon)}></i>
          </div>
        </div>

        <div className="relative">
          <div className="flex items-end gap-2">
            <span className="inline-block text-sm 2xl:text-base font-medium text-md-dark">
              {data?.name}
            </span>
            <span className="inline-block text-[10px] 2xl:text-xs text-slate-400 pb-px 2xl:pb-0.5">
              {data?.date?.dayname +
                ", " +
                data?.date?.day +
                " " +
                data?.date?.month +
                ", " +
                data?.date?.year}
            </span>
          </div>
          {data?.subdata?.length > 0 && (
            <div className="space-y-1">
              {data?.subdata?.map((subdata, subindex) => (
                <SubItem key={subindex} data={subdata} />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TrackingItem;
